<div class="ivy-face" aria-hidden="true">
  <svg [attr.width]="size" [attr.height]="size" viewBox="-30 -30 152 152" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        class="l1"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.6"
        d="M65.4703 81.1043C47.2107 91.406 15.0853 90.5255 7.24563 66.0893C-0.594084 41.6532 6.88196 19.1345 25.1415 8.83297C43.4011 -1.4686 72.8233 -7.50967 83.5083 23.064C89.4136 45.072 83.7299 70.8028 65.4703 81.1043Z"
        fill="#FFCAE6"
      />
      <path
        class="l2"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.6"
        d="M86.6979 45.5336C86.6979 66.73 70.2931 94.6593 45.382 89.542C20.471 84.4247 4.67383 66.73 4.67383 45.5336C4.67383 24.3373 7.1776 -1.29889 38.772 4.33013C60.6452 9.95906 86.6979 24.3373 86.6979 45.5336Z"
        fill="#B89AFF"
      />
      <path
        class="l3"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.6"
        d="M34.7967 84.9282C14.5727 79.4793 -7.80912 56.2905 3.55177 33.2954C14.9127 10.3004 33.4975 -3.18991 53.7216 2.2589C73.9455 7.7077 101.606 26.6671 88.0191 56.0529C76.96 75.9516 55.0208 90.377 34.7967 84.9282Z"
        fill="#FFC9F3"
      />


      <path d="M80.9163 44.4052C80.9163 25.3314 65.284 9.86908 46.0006 9.86908C26.7172 9.86908 11.085 25.3314 11.085 44.4052C11.085 63.479 26.7172 78.9414 46.0006 78.9414C65.284 78.9414 80.9163 63.479 80.9163 44.4052Z" fill="black"/>
      <g filter="none">
        <path opacity="0.3" d="M45.4699 68.3696C58.1554 68.3696 68.4389 58.1978 68.4389 45.6503C68.4389 33.1028 58.1554 22.931 45.4699 22.931C32.7845 22.931 22.501 33.1028 22.501 45.6503C22.501 58.1978 32.7845 68.3696 45.4699 68.3696Z" fill="white"/>
        <path d="M28.8189 47.7421C28.8189 57.0553 36.3029 64.6341 45.5014 64.6341C54.6997 64.6341 62.0791 57.836 62.0791 44.9891C62.0791 44.9891 53.9549 45.4838 46.8928 42.4522C39.9214 39.4589 35.4642 34.2564 35.4642 34.2564C31.3201 37.4255 28.8189 42.4162 28.8189 47.7421ZM22.6161 40.9179C25.1077 28.1702 37.3771 19.8509 49.9672 22.3736C62.5562 24.8974 70.7722 37.3206 68.2807 50.0682C67.8836 52.0984 67.3804 53.6316 66.3376 55.8944C65.4373 57.8502 63.2384 60.5814 62.6598 61.2859C60.6757 63.5814 58.2555 65.4476 55.5514 66.7614C55.5514 66.7614 55.3365 66.8346 55.0139 66.982C50.5858 69.0078 45.7151 69.5713 40.9319 68.6125C28.3407 66.0909 20.1247 53.6654 22.6161 40.9179Z" fill="white"/>
        <path d="M38.6413 48.1006C40.4878 48.1006 41.9847 46.62 41.9847 44.7935C41.9847 42.9671 40.4878 41.4865 38.6413 41.4865C36.7948 41.4865 35.2979 42.9671 35.2979 44.7935C35.2979 46.62 36.7948 48.1006 38.6413 48.1006Z" fill="white"/>
      </g>
    </g>
  </svg>
</div>
